import { StrategyDetail } from 'model/modules/strategies/strategies';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapCurrencyFromApi from 'rtkQuery/sharespro/mapper/shared/mapCurrencyFromApi';
import mapMultiItemsChartFromApi from 'rtkQuery/sharespro/mapper/shared/mapMultiItemsChartFromApi';
import { mapPortfolioPositionItemFromApi } from 'rtkQuery/sharespro/mapper/modules/portfolio/mapPortfolioDataFromApi';
import mapStrategyDealFromApi from 'rtkQuery/sharespro/mapper/modules/strategies/mapDealFromApi';

const mapStrategyDetailFromApi = (
  api: SharesproApiResponse<ApiFetchStrategyDetailResponse>
): StrategyDetail => {
  const item = api.data.item;

  return {
    intro: item.intro,
    statistics: item.statistics,
    indicators: item.indicators,
    currency: mapCurrencyFromApi(item.currency),
    modelIncome: {
      fromAmount: item.model_income.from_amount,
      toAmount: item.model_income.to_amount,
      balanceChange: item.model_income.balance_change,
      balanceChangePercent: item.model_income.balance_change_percent,
      description: item.model_income.description,
      chartImage: item.model_income.chart,
      title: item.model_income.title,
    },
    portfolioComposition: item.portfolio_composition.map((item) => ({
      volumePercent: item.volume_percent,
      name: item.ticker,
    })),
    advantages: item.advantages.map((item) => ({
      label: item.title,
      value: item.desc,
      icon: item.icon,
      help: item.help,
    })),
    about: item.about,
    incomeChart: mapMultiItemsChartFromApi(item.income_chart),
    entryAmount: item.entry_amount,
    positions: item.positions?.map(mapPortfolioPositionItemFromApi) ?? [],
    deals: item.deals?.map(mapStrategyDealFromApi) ?? [],
  };
};

export default mapStrategyDetailFromApi;
